import { IUserData } from "../../../../interfaces/user/IUserData";
import { BlogCardOptionsModalWrapper } from "./BlogCardOptionsModalWrapper";
import { BlogCardFollowProvider } from "./BlogCardFollowProvider";
import { BlogCardModalFollow } from "./BlogCardModalFollow";

type BlogCardOptionsModalProps = { coach: IUserData };

export const BlogCardOptionsModal = ({ coach }: BlogCardOptionsModalProps) => {
  return (
    <BlogCardOptionsModalWrapper>
      <BlogCardFollowProvider coach={coach}>
        <BlogCardModalFollow />
      </BlogCardFollowProvider>
    </BlogCardOptionsModalWrapper>
  );
};
